//import { any, func, string } from 'prop-types';

import React, { useEffect } from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { ComponentFooter } from "styled_components/Common/ComponentFooter";
import { Divider } from "styled_components/Common/Divider";
import { LoadingSpinner } from "styled_components/Common/LoadingSpinner";

const handleColorType = (module, theme) => {
  switch (module.toLowerCase()) {
    case "storage":
      return theme.storage;
    case "account":
      return theme.account;
    case "billing":
      return theme.billing;
    case "support":
      return theme.support;
    case "colocation":
      return theme.colocation;
    default:
      return theme.main;
  }
};
const ListStyle = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.componentBackground};
  height: 343px;
  &.lg {
    height: 528px;
    .notifications-body {
      height: 390px;
    }
  }

  #filter {
    right: 168px;
    top: -40px;
  }
  #sort {
    right: 0;
    top: -40px;
  }
  .notifications-header {
    height: 40px;
    .header-titles {
      width: 100%;
      padding-top: 15px;
      padding-left: 64px;
      padding-right: 64px;
      display: flex;

      .header-title {
        color: ${(props) => props.theme.Cool_Gray_Dark_2};
        display: flex;
        align-items: end;
        min-width: 55px;
        height: 18px;
        margin-right: 20px;
        padding-left: 10px;
        &.md {
          min-width: 80px;
        }
        &.lg {
          min-width: 150px;
        }
      }
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    //border: 1px solid red;
  }
  .notifications-body {
    position: relative;
    height: 200px;
    padding-top: 10px;
    padding-left: 64px;
    padding-right: 64px;
    cursor: pointer;
    overflow: hidden;
    .error-message {
      padding-top: 15px;
      text-align: center;
    }

    .body-row-wrapper {
      display: flex;
      width: 100%;
      margin-top: 10px;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      .body-row {
        flex: 1;

        width: 100%;
        padding-right: 10px;
        padding-top: 3px;
        display: flex;
        flex-direction: column;
        height: 25px;
        transition: height 1s ease;
        color: ${(props) => props.theme.Cool_Gray_Dark_2};
        position: relative;
        padding-left: 10px;

        .expanded-content {
          padding-top: 10px;
          margin-top: 3px;
          display: none;
          height: 100px;

          .ScrollbarsCustom-Track {
            right: 50px !important;
            top: 0px !important;
          }
          .ScrollbarsCustom-ThumbY {
            background-color: ${(props) =>
              handleColorType(props.module, props.theme)} !important;
            width: 6px !important;
          }
          .ScrollbarsCustom-TrackY:before {
            border-left: none;
          }
          .ScrollbarsCustom-TrackY {
            background-color: ${(props) =>
              props.theme.Cool_Gray_Light_2} !important;
            box-shadow: -1px -1px 1.5px ${(props) =>
                  props.theme.Cool_Gray_Light_3} inset,
              1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
            width: 6px !important;
            height: 100% !important;
          }
          .detail-list {
            min-height: 40px;
          }
          .buttons {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 10px;
            height: 20px;
            .right-button {
              margin-left: 20px;
            }
          }
        }
        .values {
          display: flex;
          width: 300px;

          .value {
            cursor: pointer;
            margin-right: 20px;
          }
        }
        &.active {
          border-radius: 4px;
          box-shadow: inset 3px 3px 4px #c7c9c9, inset -3px -3px 4px #ffffff;

          height: 90px;
          &.lg {
            height: 130px;
          }
          color: ${(props) => handleColorType(props.module, props.theme)};
          .expanded-content {
            flex-direction: column;
            position: absolute;
            color: ${(props) => props.theme.Cool_Gray_Dark_2};
            top: 20px;
            display: flex;
            height: 70px;
            width: 475px;
            &.single {
              width: 475px;
            }

            .header-titles {
              display: flex;
              width: 100%;

              .header-title {
                width: 65px;

                &.md {
                  width: 70px;
                }
                &.lg {
                  width: 240px;
                }
                &.single {
                  width: 100%;
                }
              }
            }
            .detail-row {
              display: flex;
              .detail {
                white-space: wrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 65px;
                padding-right: 10px;
                &.amount {
                  overflow: visible;
                }
                .amount {
                  display: flex;
                  height: 20px;
                  position: relative;

                  .type {
                    width: 8px;
                    position: absolute;
                    left: -8px;
                  }
                  .dollar {
                  }
                  .value {
                    width: 60px;
                    text-align: right;
                  }
                }

                &.lg {
                  width: 240px;
                }
              }
            }
          }
        }

        .value {
          min-width: 55px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-bottom: 15px;

          &.md {
            min-width: 80px;
          }
          &.lg {
            min-width: 150px;
          }
        }
      }
    }
    .body-row-wrapper:hover {
      .body-row {
        border-radius: 4px;
        box-shadow: inset 3px 3px 4px #c7c9c9, inset -3px -3px 4px #ffffff;
      }
    }
  }
  .ScrollbarsCustom-Track {
    right: -35px !important;
    top: 10px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) =>
      handleColorType(props.module, props.theme)} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 455px;
    &.lg {
      height: 752px;
      .notifications-body {
        height: 590px;
      }
    }
    #filter {
      right: 184px;
      top: -56px;
    }
    #sort {
      right: 0;
      top: -56px;
    }

    .notifications-header {
      height: 60px;
      .header-titles {
        padding-top: 35px;
        padding-left: 64px;
        padding-right: 64px;
        .header-title {
          min-width: 100px;
          height: 18px;
          margin-right: 20px;
          padding-left: 20px;
          &.md {
            min-width: 128px;
          }
          &.lg {
            min-width: 189px;
          }
        }
      }
    }
    .notifications-body {
      height: 306px;
      padding-left: 64px;
      padding-right: 64px;

      .body-row-wrapper {
        display: flex;
        width: 99%;
        margin-top: 10px;

        .body-row {
          padding-left: 20px;
          padding-right: 30px;
          padding-top: 5px;
          height: 30px;
          .expanded-content {
            height: 100px;
            padding-top: 10px;

            .ScrollbarsCustom-Track {
              right: 50px !important;
              top: 0px !important;
            }
            .ScrollbarsCustom-ThumbY {
              background-color: ${(props) =>
                handleColorType(props.module, props.theme)} !important;
              width: 6px !important;
            }

            .ScrollbarsCustom-TrackY {
              background-color: ${(props) =>
                props.theme.Cool_Gray_Light_2} !important;
              box-shadow: -1px -1px 1.5px ${(props) =>
                    props.theme.Cool_Gray_Light_3} inset,
                1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
              width: 6px !important;
              height: 100% !important;
            }

            .detail-list {
              min-height: 60px;
            }
            .buttons {
              height: 30px;
              .right-button {
                margin-left: 30px;
              }
            }
          }

          &.active {
            height: 120px;
            &.lg {
              height: 175px;
            }
            .expanded-content {
              top: 25px;
              height: 120px;
              width: 747px;
              &.single {
                width: 745px;
              }
              .label {
                min-width: 148px;
              }
              .header-titles {
                display: flex;
                width: 100%;
                .header-title {
                  width: 80px;
                  height: 20px;
                  &.md {
                    width: 70px;
                  }
                  &.lg {
                    width: 405px;
                  }
                  &.single {
                    width: 100%;
                  }
                }
              }
              .detail-row {
                display: flex;
                height: 20px;
                .detail {
                  min-width: 80px;
                  padding-right: 20px;
                  .amount {
                    .type {
                      width: 8px;
                      left: -12px;
                    }
                    .dollar {
                    }
                    .value {
                      min-width: 68px;
                    }
                  }

                  &.lg {
                    width: 405px;
                  }
                }
              }
            }
          }

          .value {
            min-width: 100px;
            padding-bottom: 15px;

            margin-right: 10px;
            &.md {
              min-width: 128px;
            }
            &.lg {
              min-width: 189px;
            }
          }
        }
      }
    }

    .ScrollbarsCustom-Track {
      right: -33px !important;
      top: 10px !important;
    }

    .ScrollbarsCustom-ThumbY {
      width: 8px !important;
    }
    .ScrollbarsCustom-TrackY {
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 687px;
    &.lg {
      height: 944px !important;
      .notifications-body {
        height: 690px;
      }
    }
    #filter {
      right: 232px;
      top: -64px;
    }
    #sort {
      right: 0;
      top: -64px;
    }

    .notifications-header {
      height: 100px;
      .header-titles {
        padding-top: 70px;
        padding-left: 136px;
        padding-right: 136px;
        .header-title {
          min-width: 185px;
          height: 16px;
          margin-right: 35px;
          padding-left: 30px;

          &.md {
            min-width: 183px;
          }
          &.lg {
            min-width: 288px;
          }
        }
      }
    }
    .notifications-body {
      height: 460px;
      padding-left: 136px;
      padding-right: 136px;
      z-index: 100;
      .body-row-wrapper {
        display: flex;
        width: 99%;
        margin-top: 10px;

        .body-row {
          padding-left: 0px;
          padding-right: 25px;
          padding-top: 5px;

          height: 30px;
          .expanded-content {
            height: 100px;
            padding-top: 10px;
            margin-left: 30px;

            .ScrollbarsCustom-Track {
              right: 50px !important;
              top: 0px !important;
            }
            .ScrollbarsCustom-ThumbY {
              background-color: ${(props) =>
                handleColorType(props.module, props.theme)} !important;
              width: 6px !important;
            }

            .ScrollbarsCustom-TrackY {
              background-color: ${(props) =>
                props.theme.Cool_Gray_Light_2} !important;
              box-shadow: -1px -1px 1.5px ${(props) =>
                    props.theme.Cool_Gray_Light_3} inset,
                1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
              width: 6px !important;
              height: 100% !important;
            }
            .detail-list {
              min-height: 90px;
              margin-bottom: 15px;
            }
            .buttons {
              .right-button {
                margin-left: 40px;
              }
            }
          }

          &.active {
            height: 200px;
            &.lg {
              height: 240px;
            }
            .expanded-content {
              top: 30px;
              height: 120px;
              width: 1210px;
              &.single {
                width: 1210px;
              }
              .label {
                min-width: 215px;
              }
              .header-titles {
                display: flex;
                width: 100%;
                .header-title {
                  width: 125px;
                  height: 20px;
                  &.md {
                    width: 75px;
                  }
                  &.lg {
                    width: 755px;
                  }
                  &.single {
                    width: 100%;
                  }
                }
              }
              .detail-row {
                display: flex;
                height: 25px;
                .detail {
                  min-width: 125px;
                  padding-right: 25px;
                  .amount {
                    .type {
                      width: 8px;
                      left: -12px;
                    }
                    .dollar {
                    }
                    .value {
                      min-width: 80px;
                      padding-left: 0px;
                    }
                  }
                  &.lg {
                    width: 755px;
                  }
                }
              }
            }
          }

          .value {
            min-width: 185px;
            padding-bottom: 15px;
            margin-right: 35px !important;

            padding-left: 30px;
            &.md {
              min-width: 183px;
            }
            &.lg {
              min-width: 288px;
            }
          }
        }
      }
    }

    .ScrollbarsCustom-Track {
      right: -69px !important;
      top: 10px !important;
    }

    .ScrollbarsCustom-ThumbY {
      width: 10px !important;
    }
    .ScrollbarsCustom-TrackY {
      width: 10px !important;
    }
  }
`;

function toggleActive(id, onClickFunc, invoiceId) {
  const selected = document.getElementById(id);
  const currentSelected = document.querySelector(`.active`);
  onClickFunc(invoiceId);
  if (currentSelected) {
    currentSelected.classList.remove("active");
  }

  if (selected !== currentSelected) {
    selected.classList.toggle("active");
  }
}

export const ListComponent = ({
  className,
  id,
  module,
  children,
  data,
  headers,
  location,
  loading,
}) => {
  useEffect(() => {
    if (location?.state?.invoiceNumber) {
      const elementId = `right-button-#${location?.state?.invoiceNumber}`;
      const selected = document.getElementById(elementId);

      if (selected) {
        selected.click();
      }
    }
  }, [data, loading]);

  return (
    <ListStyle id={id} className={className} module={module}>
      <div className="notifications-header">
        <div className="header-titles">
          {headers &&
            headers.map((header) => (
              <div className={`header-title ${header?.size} labels21`}>
                {header?.label}
              </div>
            ))}
        </div>
      </div>
      <div className="notifications-body">
        <Divider />
        <ScrollView>
          {data &&
            data.map((item, key) => {
              const values = item?.values;
              const expandedHeaders = item?.expandedHeaders;
              const expandedValues = item?.expandedValues;
              const function1 = item?.button1?.onClick;
              const function2 = item?.button2?.onClick;
              const onClickFunc = item?.onClick;

              return (
                <div
                  className="body-row-wrapper"
                  onClick={
                    !loading
                      ? () =>
                          toggleActive(`body-row-${key}`, onClickFunc, item?.id)
                      : () => {}
                  }
                  data-cy={`body-row-${key}`}
                >
                  <div
                    className={`body-row ${item?.expandedSize}`}
                    id={`body-row-${key}`}
                    index={`${key}-${item.startDate}`}
                    //eslint-disable-next-line
                    key={`${key}-${item?.startDate}`}
                  >
                    <div className="values">
                      {values &&
                        values.map((value) => (
                          <div className={`value ${value?.size} body10`}>
                            {value?.label}
                          </div>
                        ))}
                    </div>

                    <div
                      className={`expanded-content ${
                        expandedHeaders?.length === 1 ? "single" : ""
                      }`}
                    >
                      <Divider />
                      <div className="header-titles">
                        {expandedHeaders &&
                          expandedHeaders.map((header) => (
                            <div
                              className={`header-title ${header?.size} labels21`}
                            >
                              {header?.label}
                            </div>
                          ))}
                      </div>
                      <div className="detail-list">
                        <ScrollView>
                          {expandedValues &&
                            expandedValues.length !== 0 &&
                            expandedValues.map((value) => {
                              return (
                                <div className="detail-row">
                                  <div
                                    className={`detail ${value?.one?.size} body10`}
                                  >
                                    {value?.one?.value}
                                  </div>

                                  <div
                                    className={`detail ${value?.two?.size} body10`}
                                  >
                                    {value?.two?.value}
                                  </div>
                                  <div
                                    className={`detail ${
                                      value?.three?.size
                                    } body10 ${
                                      value?.three?.amount ? "amount" : ""
                                    }`}
                                  >
                                    {!value?.three?.amount &&
                                      value?.three?.value}
                                    {value?.three?.amount && (
                                      <div className="amount">
                                        {value?.three?.type && (
                                          <div className="type">
                                            {value?.three?.type === "credit"
                                              ? "+"
                                              : "-"}
                                          </div>
                                        )}
                                        <div className="dollar">$</div>
                                        <div className="value">
                                          {value?.three?.value}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          {expandedValues.length === 0 && !loading && (
                            <div className="no-data body10">
                              No data to display.
                            </div>
                          )}
                          {expandedValues.length === 0 && loading && (
                            <div className="loading body10">
                              <LoadingSpinner />
                            </div>
                          )}
                        </ScrollView>
                      </div>
                      {item?.button1 && (
                        <div className="buttons">
                          <BloxButton
                            text={item?.button1?.text}
                            module={module}
                            enabled={true}
                            className="buttons41"
                            id="left-buuton"
                            cypressId={`list-component-button-1-${key}`}
                            onClick={() =>
                              function1(item?.id, item?.type, item?.docId)
                            }
                          />
                          <BloxButton
                            text={item?.button2?.text}
                            enabled={true}
                            module={module}
                            className="right-button buttons41"
                            id={`right-button-${item?.key}`}
                            cypressId={`list-component-button-2-${key}`}
                            onClick={() =>
                              function2(item?.id, item?.key, item?.docId)
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </ScrollView>
      </div>
      <ComponentFooter
        cypressId="notifications-footer"
        id="notifications-footer"
        //buttonText1={data?.button1?.text}
        //buttonText2={data?.button2?.text}
        buttonActive1={true}
        buttonActive2={true}
        module={module}
        //buttonFunction1={data?.button1?.onClick}
        //size={getSize(breakpoint)}
        //buttonFunction2={data?.button2?.onClick}
      />
      {children}
    </ListStyle>
  );
};
ListComponent.propTypes = {};

ListComponent.defaultProps = {};
